import { handleResponse, authHeader } from '../_helpers';
import { BASE_URL, AHL_CHARITY_ID } from "../../common/constant";
import { authContext } from '../../data/authContext';
import { decryptData, getSecret } from '../../common/common';
import { SSMKeys } from '../../common/common';

export const profile = {
    getUserData,
    getCardData,
    getCardDetails,
    transactionListing,
    checkUserExistsByEmail,
    checkCogntioAndCreateGPDonor,
};

// Check if account exists with given email and create user in GP table
async function checkCogntioAndCreateGPDonor(data) {
  
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    const url = BASE_URL + `/User/checkCogntioAndCreateGPDonor`; 
    
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result;
            } else {
                return false;
            }
            
        }).catch(error => {
           
            return [];
        });
}

// Check if account exists with given email
async function checkUserExistsByEmail(email, userName = "") {
  
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const url = BASE_URL + `/User/getCognitoUser?email=` + email + `&userName=`+ userName; 
    
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result;
            } else {
                return false;
            }
            
        }).catch(error => {
           
            return [];
        });
}

async function getUserData(userDetails) {
  
        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify(userDetails)
        };
        const url = BASE_URL + `/User/getSignInUserDetails`; 
        return fetch(url, requestOptions)
            .then(handleResponse)
            .then(result => {
                
                 if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                    return result;
                }
            }).catch(error => {
               
                return [];
            });
    }

async function getCardData(guid) {
    
    const requestOptionsForStripe = {
        method: 'GET',
        headers: authHeader(),
    };
    const url = BASE_URL + `/User/getUserStripeToken?Guid=` + guid +'&charityId='+ AHL_CHARITY_ID; 
    
    return fetch(url, requestOptionsForStripe)
        .then(handleResponse)
        .then(result => {
            
            if (result.data.userStripeTokens.result !== null && result.data.userStripeTokens.result !== undefined) {
                let resultData = result.data.userStripeTokens.result;
                return resultData;
            }
        }).catch(error => {
            return [];
        });
}

async function getCardDetails(cardId, customerId) {
    const STRIPE_KEY = await getSecret(SSMKeys.stripePk).then((res) => decryptData(res));
    const requestOptionsForStripe = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + STRIPE_KEY },
    };

    return fetch('https://api.stripe.com/v1/customers/' + customerId + '/sources/' + cardId, requestOptionsForStripe)
        .then(handleResponse)
        .then(result => {
            
            return result;
        }).catch(error => {
            return [];
        });

}

// async function getCardDetails() {

//     const y = await getCardData();
//     const card = y.data.userStripeTokens.result;
//     // console.log(y);
//     let cardsData = [];

//    const requestOptionsForStripe = {
//         method: 'GET',
//         headers: { 'Authorization': 'Bearer ' + STRIPE_SECRCT },
//     };
//     const listItems = card.map((item, index) => {
//         console.log(item.customerId);
//     let url = 'https://api.stripe.com/v1/customers/' + item.customerId + '/sources/' + item.cardId;
//     return fetch(url, requestOptionsForStripe)
//         .then(handleResponse)
//         .then(result => {
//             console.log(result);
//             return result;
//         }).catch(error => {
//             return [];
//         });
//         });
//         console.log(listItems);
        
// }

async function transactionListing(transactionData) {
    // let data = {
    //     guid : authContext.guid ?? '',
    //     charityId: AHL_CHARITY_ID,
    //     pageNumber : 1
    // } 
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(transactionData)
    };
    const url = BASE_URL + `/v1/Donation/getUserTransactions`; 
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            
             if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result;
            }
        }).catch(error => {
           
            return [];
        });
}
